import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllMessage } from '../../store/message';
import './Message.css'

function Message() {
  const dispatch = useDispatch()
  const allMessages = useSelector(state => state.message)
  const [loaded, setLoaded] = useState(false)
  const [showImportant, setShowImportant] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  let messageArr;
  let recent;
  let lines;
  useEffect(() => {
    dispatch(getAllMessage())
  }, [dispatch])

  // Fetch whether the important message should be shown
  useEffect(() => {
    const fetchShowMessage = async () => {
      try {
        const res = await fetch('/api/messages/show-message')
        if (res.ok) {
          const data = await res.json()
          const displayFlag = !!data.display
          setShowImportant(displayFlag)
          // Default expanded when important message is set to display
          setIsExpanded(displayFlag)
        }
      } catch (e) {
        // noop: if this fails, keep defaults
      }
    }
    fetchShowMessage()
  }, [])

  useEffect(() => {
    setLoaded(true)
  }, [messageArr])

  if (allMessages) {
    messageArr = Object.values(allMessages)
    recent = messageArr[messageArr.length - 1]
    if (recent)(
      lines = recent.message.split('newline')
    )
  }


  // Accessibility: allow keyboard activation of the label
  const onLabelKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault()
      setIsExpanded(prev => !prev)
    }
  }

  return loaded && lines ? (
    <div className="message-container">
      <input
        id='collapsible'
        className='message-toggle'
        type='checkbox'
        checked={isExpanded}
        onChange={() => setIsExpanded(prev => !prev)}
      />
      <label
        htmlFor='collapsible'
        className='message-toggle-label'
        onKeyDown={onLabelKeyDown}
        tabIndex={0}
        aria-expanded={isExpanded}
      >
        Important Messages
      </label>
      <div className='message-collapsible-content'>
        <div className='message-content'>
          {lines.map((line, ind) => {
            return (
              <p key={ind}>
                {line}
              </p>
            )
          })}
        </div>
      </div>
    </div>
    // TEMPORARY - Jan 5, 2025
    // <div className="message-container">
    //   {/* <input id='collapsible' className='message-toggle' type='checkbox'></input> */}
    //   <label for='collapsible' className='message-toggle-label'>Important Messages</label>
    //   {/* <div className='message-collapsible-content'> */}
    //     <div className='message-content'>
    //       {lines.map((line, ind) => {
    //         return (
    //           <p key={ind}>
    //             {line}
    //           </p>
    //         )
    //       })}
    //     </div>
      // {/* </div> */}
    // </div>

  ) : (
    <h1>Loading...</h1>
  )
}
export default Message